<template>
  <div v-if="showtable" className="animated" class="animated fadeIn">
    <v-client-table
      :key="$route.params.product_id"
      :data="tableData"
      :columns="getColumns"
      :options="getOptions"
      @row-click="(e) => debug(e.row)"
      ref="table"
    >
      <template slot="afterFilter">
        <tr class="VueTables__no-results">
          <b-button class="mr-2" @click.prevent="resetFilters">Limpiar filtro</b-button>
          <!-- <download-excel class="btn" :fields="getJsonFields" worksheet="Stock" :data="tableData" :name="name">
            <b-button class="mr-2">Descargar <i class="fa fa-download text-muted"></i> </b-button>
          </download-excel> -->
          <b-button class="mr-2" @click.prevent="downloadHtml()">Descargar</b-button>
        </tr>

        <tr v-if="loading" class="VueTables__no-results">
          <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
        </tr>
      </template>

      <template slot="h__quantity">
        Cantidad <br />
        <b-badge>{{ sumColumn("quantity") | formatNumber }}</b-badge>
      </template>
      <template slot="h__net_kilograms">
        KN <br />
        <b-badge>{{ sumColumn("net_kilograms") | formatNumber }}</b-badge>
      </template>
      <template slot="daystay" slot-scope="props">
        <div style="text-align: right">
          <b-badge pill :variant="getDaystayBadge(props.row.daystay)">
            {{ props.row.daystay }}
          </b-badge>
        </div>
      </template>
      <div slot="beforeLimit"></div>
      <div slot="net_kilograms" slot-scope="props">
        <div style="text-align: right">
          {{ props.row.net_kilograms }}
        </div>
      </div>
      <div slot="quantity" slot-scope="props">
        <div style="text-align: right">{{ props.row.quantity }}</div>
      </div>
      <div slot="waybill_number" slot-scope="props">
        <div style="text-align: right">{{ props.row.waybill_number }}</div>
      </div>
      <div slot="in_process" slot-scope="props">
        <div style="text-align: right" v-if="props.row.in_process">
          {{ props.row.in_process }}
        </div>
      </div>
      <div slot="creation_date" slot-scope="props">
        <div style="text-align: right">
          {{ props.row.creation_date | moment }}
        </div>
      </div>
      <div slot="waybill_date" slot-scope="props">
        <div style="text-align: right">{{ props.row.waybill_date }}</div>
      </div>
      <!-- <div slot="last_inspection" slot-scope="props">
        <div v-if="props.row.last_inspection.name">
          <span :class="getBadgeInspection(props.row.last_inspection.color)">{{ props.row.last_inspection.name }}</span>
        </div>
      </div> -->
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import { mapGetters } from "vuex";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import labelize from "@/assets/js/utils.js";
import downloadHtml from "@/assets/js/downloadHtml.js";
import { getBootstrapColorName } from "../../utils";

numeral.locale("es");
moment.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ClientTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "DataTable",
  components: {
    ClientTable
  },
  created() {},
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    this.getProductCustomFields(this.$route.params.product_id).then(() => {
      this.getTableData();
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  beforeMount() {},
  data() {
    return {
      ready: false,
      showtable: false,
      loading: false,
      tableData: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      data: [],
      productSet: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        rowClassCallback: function (row) {
          return row.is_complete
            ? "font-weight-bold"
            : row.inspections[0]
            ? " bg-" + getBootstrapColorName(row.inspections[0].color)
            : "";
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 25,
        perPageValues: [15, 25, 50, 100],
        // columnsDropdown: true,
        filterByColumn: true,
        debounce: 100,
        columnsDropdown: true,
        sortable: true,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      export_custom_fields: {},
      bulk_custom_fields: {},
      lot_custom_fields: {},
      custom_fields_list: []
    };
  },
  filters: {
    moment(value) {
      return moment(value).format("DD-MM-YYYY");
    },
    number(value) {
      numeral(value).format("0.0,0");
    }
  },
  watch: {
    selected: {
      handler(val) {
        this.getProductSet(this.selected.product);
      },
      deep: true
    },
    tableRef() {
      console.log("ACAACK!!! 🐔");
    }
  },
  computed: {
    ...mapGetters(["getCustomFieldsList"]),
    getColumns() {
      return [
        "client_customer_name",
        "plant_name",
        "pallet_number",
        "lot_number",
        "product_name",
        "product_type_name",
        "condition",
        "variety_name",
        "container_code",
        "container_name",
        "container_description",
        "quantity",
        "net_kilograms",
        "creation_date",
        "processed_in",
        // 'waybill_number',
        // 'waybill_date',
        "classification",
        "daystay",
        "string_specs",
        "origin_name",
        "company_name",
        // "in_process",
        "document",
        // "involved_waybills",
        // "last_inspection",
        "position",
        "approved",
        ...this.custom_fields_list
      ];
    },
    getJsonFields() {
      let json_fields = {
        Exportadora: "client_customer_name",
        Planta: "plant_name",
        Pallet: "pallet_number",
        Lote: "lot_number",
        Especie: "product_name",
        Tipo: "product_type_name",
        Huerto: "origin_name",
        CSG: "origin_code",
        "Procesado en": "processed_in",
        Condicion: "condition",
        Variedad: "variety_name",
        Codigo: "container_code",
        Formato: "container_name",
        Descripcion: "container_description",
        "Fecha Creacion": "creation_date",
        Cantidad: "quantity",
        KN: {
          field: "net_kilograms",
          callback: (value) => {
            return numeral(parseFloat(value)).format("0.00");
          }
        },
        "Días estadía": "daystay",
        Especificaciones: "string_specs",
        Documento: "document",
        // 'KB' : {
        //   field: 'gross_kilograms',
        //   callback: (value) => {
        //     return numeral(value).format('0.00');
        //   },
        // },
        "Fecha Guia": "waybill_date",
        "Guia Despacho": "waybill_number",
        "En Proceso": "in_process",
        Guias: "involved_waybills",
        Inspeccion: "last_inspection.name",
        Clasificacion: "classification",
        Posicion: "position",
        Estado: "approved"
      };
      for (var i in this.custom_fields_list) {
        json_fields[labelize(this.custom_fields_list[i].split(".")[1])] = this.custom_fields_list[i];
      }
      return json_fields;
    },
    getOptions() {
      let options = this.options;
      options.headings = this.getHeadings;
      options.columnsDisplay = this.getColumnsDisplay;
      return options;
    },
    getColumnsDisplay() {
      let c_display = {
        document: "not_desktop",
        product_name: "not_desktop",
        processed_in: "not_desktop",
        classification: "not_desktop",
        company_name: "not_desktop",
        product_type_name: "min_desktop",
        container_description: "not_desktop",
        string_specs: "not_desktop",
        daystay: "min_desktop",
        condition: "min_desktop",
        lot_number: "min_desktop",
        in_process: "not_desktop",
        involved_waybills: "not_desktop",
        last_inspection: "not_desktop",
        position: "not_desktop",
        approved: "not_desktop"
      };
      for (var i in this.custom_fields_list) {
        c_display[this.custom_fields_list[i]] = "not_desktop";
      }
      return c_display;
    },
    getHeadings() {
      let headings = {
        client_customer_name: "Exportadora",
        plant_name: "Planta",
        pallet_number: "Pallet",
        product_name: "Especie",
        product_type_name: "Tipo Producto",
        container_description: "Descripción",
        condition: "Condición",
        lot_number: "Lote",
        processed_in: "Procesado en",
        in_process: "En Proceso",
        classification: "Clasificación",
        variety_name: "Variedad",
        container_code: "Código",
        container_name: "Formato",
        quantity: "Cantidad",
        net_kilograms: "KN",
        daystay: "Días estadía",
        string_specs: "Especificaciones",
        origin_name: "Huerto",
        company_name: "Productor",
        document: "Documento",
        creation_date: "Fecha Creación",
        involved_waybills: "Guías",
        last_inspection: "Inspección",
        position: "Posición",
        approved: "Estado"
      };
      for (var i in this.custom_fields_list) {
        headings[this.custom_fields_list[i]] = labelize(this.custom_fields_list[i].split(".")[1]);
      }
      return headings;
    },
    name() {
      return "Stock " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    sumMarkedKilograms() {
      let total = 0;
      // total += this.data.reduce((acc, item) => acc + item.net_kilograms.value(), 0);
      total = numeral(total);
      return total;
    },
    tableRef() {
      return this.$refs.table;
    }
  },
  methods: {
    debug(a) {
      console.log(a);
    },
    sumColumn(column) {
      let total = 0;
      const data = this.$refs.table;
      if (data) {
        total += data.filteredData.reduce((acc, item) => acc + parseFloat(item[column]), 0);
      }
      return total;
    },
    downloadHtml() {
      downloadHtml(this.$refs.table.allFilteredData, this.getColumns, this.getHeadings, "Stock");
    },
    getCompleteCustomFieldsList() {
      let arr = [];
      // Add the rest Custom Fields to the List
      for (var item in this.getCustomFieldsList) {
        arr.push(this.getCustomFieldsList[item]);
      }

      // Add Export Custom Fields to the List
      for (var key in this.export_custom_fields) {
        if (this.export_custom_fields.hasOwnProperty(key)) {
          const elements = _.map(this.export_custom_fields[key], "name");
          for (var i in elements) {
            arr.push("custom_fields." + elements[i]);
          }
        }
      }
      // Add Bulk Custom Fields to the List
      for (var key in this.bulk_custom_fields) {
        if (this.bulk_custom_fields.hasOwnProperty(key)) {
          const elements = _.map(this.bulk_custom_fields[key], "name");
          for (var i in elements) {
            arr.push("custom_fields." + elements[i]);
          }
        }
      }
      // Add Lot Custom Fields to the List
      for (var key in this.lot_custom_fields) {
        if (this.lot_custom_fields.hasOwnProperty(key)) {
          const elements = _.map(this.lot_custom_fields[key], "name");
          for (var i in elements) {
            arr.push("lot_custom_fields." + elements[i]);
          }
        }
      }
      this.custom_fields_list = arr;
    },
    async getTableData(e) {
      const thisV = this;
      thisV.loading = true;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: `api/v1/content/cached_stock/?product_id=${thisV.$route.params.product_id}`
        });
        thisV.tableData = response.data;
        thisV.loading = false;
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.detail, "");
        thisV.loading = false;
      }
    },
    jsonToQueryString(json) {
      var result = {};
      for (var key in json) {
        if (json[key] !== "") {
          result[key] = json[key];
        }
      }

      var a = encodeURIComponent(JSON.stringify(result));

      return "/api/v1/stock/?query=" + a;
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },

    async fetchData() {
      const response = await this.$axios.get(this.jsonToQueryString(this.$refs.table.query));
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    getBadge(condition) {
      return condition === "Orgánico" ? "primary" : "success";
    },
    getBadgeInspection(color) {
      return `badge badge-${color}`;
    },
    getDaystayBadge(daystay) {
      return daystay >= 10 ? "danger" : daystay >= 5 ? "warning" : daystay >= 3 ? "success" : "primary";
    },
    async getProductCustomFields(a) {
      const thisV = this;
      try {
        const res = await thisV.$axios.get("/production/get_product_custom_fields/" + a);
        thisV.export_custom_fields = res.data.export_custom_fields;
        thisV.bulk_custom_fields = res.data.bulk_custom_fields;
        thisV.lot_custom_fields = res.data.lot_custom_fields;
        thisV.getCompleteCustomFieldsList();
        thisV.showtable = true;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
>>> .VueTables__filters-row.form-control {
  height: calc(0.5em + 0.75rem + 2px);
}

>>> .VuePagination {
  text-align: center;
  justify-content: center;
}

>>> .table td {
  padding: 0.15em;
}

>>> .vue-title {
  text-align: center;
  margin-bottom: 10px;
}

>>> .VueTables__search-field {
  display: flex;
}
>>> .VueTables__search-field input {
  margin-left: 0.12rem;
}

>>> .VueTables__limit-field {
  display: flex;
}

>>> .VueTables__limit-field select {
  margin-left: 0.1rem !important;
}

>>> .VueTables__table th {
  text-align: center;
  padding: 0.1rem;
}

>>> .VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

>>> .VueTables__child-row-toggler--closed::before {
  content: "+";
}
>>> .VueTables__columns-dropdown {
  padding-right: 20px;
}
>>> .VueTables__date-filter {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
>>> .VueTables__number-field {
  border: 4px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
>>> .VueTables__child-row-toggler--open::before {
  content: "-";
}
</style>
